import m from "mithril";
import Component_Unit_Upload_Settings from "./component_unit_upload_settings";
import i18n from "../../../shared/i18n/i18n";
import Unit_Courses from "../unit_courses";

let loading = false;
let tab = "settings";
let unit = null;


const Page_Unit_Upload = {
    oninit: function (vnode) {
        unit = vnode.attrs.unit;
        tab = "settings";
    },
    view: function () {
        return [
            m(".content-box", [
                m(".toolbar", {class: loading ? "disable-buttons" : ""}, [
                    m(".toolbar-section with-menu", [
                        m("h1", i18n.t("upload_unit")),
                        m(".toolbar-menu", [
                            m("div", {
                                class: tab === "settings" ? "active" : "", onclick: function () { tab = "settings"; }
                            }, i18n.t("settings")),
                            m("div", {
                                class: tab === "courses" ? "active" : "", onclick: function () { tab = "courses"; }
                            }, i18n.t("courses"))
                        ])
                    ])
                ])
            ]),
            !loading ? [
                unit ? [
                    tab === "courses" ? m(Unit_Courses, {unitId: unit.properties.id})
                        : m(Component_Unit_Upload_Settings, {unit: unit.properties, onCoursesClick: function() { tab = "courses"; }})
                ] : m(".text-gray padding", i18n.t("unable_to_load_unit"))
            ] : m(".text-gray padding", [i18n.t("loading"), m(".loading-dots")])
        ];
    }
}
export default Page_Unit_Upload;
